module.exports = __webpack_public_path__ + "img/Notarzteinsatzfahrzeug.90bd43a9.svg";